import React, { useEffect, useState } from "react";
import { CardBody, Row, Col, Card, Table, CardHeader, Container } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { Link, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getInvoices as onGetInvoices } from "../../slices/thunks";
import { invoiceTable } from "../../common/data/invoiceList";
import { getOrder } from "../../api/ecommerce";

import logoDark from "../../assets/images/logo-dark.png";
import logoLight from "../../assets/images/logo-light.png";

const InvoiceDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const { invoices } = useSelector((state) => state.Invoice);
  const [invoice, setInvoice] = useState(null);

  useEffect(() => {
    if (invoices && !invoices.length) {
      dispatch(onGetInvoices());
    }
  }, [dispatch, invoices]);

  useEffect(() => {
    const dataList = invoices && invoices.length > 0 ? invoices : invoiceTable;
    if (id) {
       getOrder(id).then(data => {
           if(data) {
               let parsedItems = [];
               try {
                   parsedItems = typeof data.items === 'string' ? JSON.parse(data.items) : (data.items || []);
               } catch(e) {}
               
               const formattedItems = parsedItems.map(item => ({
                   name: item.name,
                   description: item.description || "Product Item",
                   rate: item.price ? `£${item.price}` : (item.rate || "£0.00"),
                   quantity: item.quantity ? String(item.quantity).padStart(2, '0') : "01",
                   amount: item.total ? `£${item.total}` : (item.amount || "£0.00")
               }));

               setInvoice({
                   ...data,
                   invoiceId: `#${data.order_number}`,
                   name: data.email,
                   date: data.created_at,
                   products: formattedItems.length > 0 ? formattedItems : undefined,
                   sub_total: `£${data.subtotal}`,
                   estimated_tax: `£${data.tax_total}`,
                   discount: `- £${data.discount || '0.00'}`,
                   shipping_charge: `£${data.shipping_cost}`,
                   total_amount: `£${data.total}`,
                   amount: `£${data.total}`,
                   billing_address: data.shipping_address,
                   payment_details: { method: data.payment_method || 'Mastercard', total_amount: `£${data.total}` }
               });
           }
       }).catch(err => {
           const foundInvoice = dataList.find(inv => (inv._id || inv.id || inv.invoiceId?.replace('#', '')).toString() === id.toString() || inv.invoiceId === id);
           if (foundInvoice) {
               setInvoice(foundInvoice);
           }
       });
    } else if (dataList.length > 0) {
       setInvoice(dataList[0]);
    }
  }, [id, invoices]);

  //Print the Invoice
  const printInvoice = () => {
    window.print();
  };

  document.title = "Invoice Details - Topcoinland ";

  if (!invoice) {
      return (
          <div className="page-content">
              <Container fluid>
                  <div className="d-flex justify-content-center mt-5">
                      <div className="spinner-border text-primary" role="status">
                          <span className="sr-only">Loading...</span>
                      </div>
                  </div>
              </Container>
          </div>
      );
  }

  const productsList = typeof invoice.products === 'string' ? JSON.parse(invoice.products || '[]') : (invoice.products || [
    { name: "Sweatshirt for Men (Pink)", description: "Graphic Print Men & Women Sweatshirt", rate: "£119.99", quantity: "02", amount: "£239.98" },
    { name: "Noise NoiseFit Endure Smart Watch", description: "32.5mm (1.28 Inch) TFT Color Touch Display", rate: "£94.99", quantity: "01", amount: "£94.99" },
    { name: "350 ml Glass Grocery Container", description: "Glass Grocery Container (Pack of 3, White)", rate: "£24.99", quantity: "01", amount: "£24.99" },
    { name: "Fabric Dual Tone Living Room Chair", description: "Chair (White)", rate: "£340.00", quantity: "01", amount: "£340.00" }
  ]);
  const billingAddr = typeof invoice.billing_address === 'string' ? JSON.parse(invoice.billing_address || '{}') : (invoice.billing_address || {});
  const shippingAddr = typeof invoice.shipping_address === 'string' ? JSON.parse(invoice.shipping_address || '{}') : (invoice.shipping_address || {});
  const paymentDetails = typeof invoice.payment_details === 'string' ? JSON.parse(invoice.payment_details || '{}') : (invoice.payment_details || {});

  const getAddressName = (addr) => addr.fullName || addr.name || invoice.name || "David Nichols";
  const getAddressLine = (addr) => {
    if (addr.addressLine1) {
      return `${addr.addressLine1}${addr.addressLine2 ? ', ' + addr.addressLine2 : ''}, ${addr.city}, ${addr.state} ${addr.zip}, ${addr.country}`;
    }
    return addr.address || "305 S San Gabriel Blvd";
  };
  const getAddressPhone = (addr) => addr.phone || "(123) 456-7890";
  const getAddressTax = (addr) => addr.tax || "12-3456789";

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Invoice Details" pageTitle="Invoices" />

        <Row className="justify-content-center">
          <Col xxl={9}>
            <Card id="demo">
              <Row>
                <Col lg={12}>
                  <CardHeader className="border-bottom-dashed p-4">
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <img
                          src={logoDark}
                          className="card-logo card-logo-dark"
                          alt="logo dark"
                          height="17"
                        />
                        <img
                          src={logoLight}
                          className="card-logo card-logo-light"
                          alt="logo light"
                          height="17"
                        />
                        <div className="mt-sm-5 mt-4">
                          <h6 className="text-muted text-uppercase fw-semibold">
                            Address
                          </h6>
                          <p className="text-muted mb-1" id="address-details">
                            {invoice.country || "California, United States"}
                          </p>
                          <p className="text-muted mb-0" id="zip-code"><span>Zip-code: 90201</span></p>
                        </div>
                      </div>
                      <div className="flex-shrink-0 mt-sm-0 mt-3">
                        <h6>
                          <span className="text-muted fw-normal">
                            Legal Registration No:
                          </span>{" "}
                          <span id="legal-register-no">987654</span>
                        </h6>
                        <h6>
                          <span className="text-muted fw-normal">Email:</span>{" "}
                          <span id="email">{invoice.email || "admin@TopCoinland.com"}</span>
                        </h6>
                        <h6>
                          <span className="text-muted fw-normal">Website:</span>{" "}
                          <Link to="#" className="link-primary" id="website">
                            www.TopCoinland.com
                          </Link>
                        </h6>
                        <h6 className="mb-0">
                          <span className="text-muted fw-normal">Contact No:</span>{" "}
                          <span id="contact-no"> +(01) 234 6789</span>
                        </h6>
                      </div>
                    </div>
                  </CardHeader>
                </Col>
                <Col lg={12}>
                  <CardBody className="p-4">
                    <Row className="g-3">
                      <Col lg={3} xs={6}>
                        <p className="text-muted mb-2 text-uppercase fw-semibold">
                          Invoice No
                        </p>
                        <h5 className="fs-14 mb-0">#<span id="invoice-no">{invoice.invoiceId?.replace('#', '') || "VL25000355"}</span></h5>
                      </Col>
                      <Col lg={3} xs={6}>
                        <p className="text-muted mb-2 text-uppercase fw-semibold">
                          Date
                        </p>
                        <h5 className="fs-14 mb-0">
                          <span id="invoice-date">{invoice.date || "23 Nov, 2021"}</span> <small className="text-muted" id="invoice-time">{invoice.time || "02:36PM"}</small>
                        </h5>
                      </Col>
                      <Col lg={3} xs={6}>
                        <p className="text-muted mb-2 text-uppercase fw-semibold">
                          Payment Status
                        </p>
                        <span className={`badge bg-${invoice.statusClass || "success"}-subtle text-${invoice.statusClass || "success"} fs-11`} id="payment-status">{invoice.status || "Paid"}</span>
                      </Col>
                      <Col lg={3} xs={6}>
                        <p className="text-muted mb-2 text-uppercase fw-semibold">
                          Total Amount
                        </p>
                        <h5 className="fs-14 mb-0"><span id="total-amount">{invoice.amount || invoice.total_amount || "£755.96"}</span></h5>
                      </Col>
                    </Row>
                  </CardBody>
                </Col>
                <Col lg={12}>
                  <CardBody className="p-4 border-top border-top-dashed">
                    <Row className="g-3">
                      <Col sm={6}>
                        <h6 className="text-muted text-uppercase fw-semibold mb-3">
                          Billing Address
                        </h6>
                        <p className="fw-medium mb-2" id="billing-name">{getAddressName(billingAddr)}</p>
                        <p className="text-muted mb-1" id="billing-address-line-1">{getAddressLine(billingAddr)}</p>
                        <p className="text-muted mb-1"><span>Phone: +</span><span id="billing-phone-no">{getAddressPhone(billingAddr)}</span></p>
                        <p className="text-muted mb-0"><span>Tax: </span><span id="billing-tax-no">{getAddressTax(billingAddr)}</span></p>
                      </Col>
                      <Col sm={6}>
                        <h6 className="text-muted text-uppercase fw-semibold mb-3">
                          Shipping Address
                        </h6>
                        <p className="fw-medium mb-2" id="shipping-name">{getAddressName(shippingAddr)}</p>
                        <p className="text-muted mb-1" id="shipping-address-line-1">{getAddressLine(shippingAddr)}</p>
                        <p className="text-muted mb-1"><span>Phone: +</span><span id="shipping-phone-no">{getAddressPhone(shippingAddr)}</span></p>
                      </Col>
                    </Row>
                  </CardBody>
                </Col>
                <Col lg={12}>
                  <CardBody className="p-4">
                    <div className="table-responsive">
                      <Table className="table-borderless text-center table-nowrap align-middle mb-0">
                        <thead>
                          <tr className="table-active">
                            <th scope="col" style={{ width: "50px" }}>
                              #
                            </th>
                            <th scope="col" className="text-start">Product Details</th>
                            <th scope="col">Rate</th>
                            <th scope="col">Quantity</th>
                            <th scope="col" className="text-end">
                              Amount
                            </th>
                          </tr>
                        </thead>
                        <tbody id="products-list">
                          {productsList.map((product, idx) => (
                            <tr key={idx}>
                              <th scope="row">{(idx + 1).toString().padStart(2, '0')}</th>
                              <td className="text-start">
                                <span className="fw-medium">
                                  {product.name}
                                </span>
                                <p className="text-muted mb-0">
                                  {product.description}
                                </p>
                              </td>
                              <td>{product.rate}</td>
                              <td>{product.quantity}</td>
                              <td className="text-end">{product.amount}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                    <div className="border-top border-top-dashed mt-2">
                      <Table className="table table-borderless table-nowrap align-middle mb-0 ms-auto" style={{ width: "250px" }}>
                        <tbody>
                          <tr>
                            <td>Sub Total</td>
                            <td className="text-end">{invoice.sub_total || "£699.96"}</td>
                          </tr>
                          <tr>
                            <td>Estimated Tax (12.5%)</td>
                            <td className="text-end">{invoice.estimated_tax || "£87.50"}</td>
                          </tr>
                          <tr>
                            <td>Discount <small className="text-muted">{invoice.discount_code ? `(${invoice.discount_code})` : "(VELZON15)"}</small></td>
                            <td className="text-end">{invoice.discount || "- £53.99"}</td>
                          </tr>
                          <tr>
                            <td>Shipping Charge</td>
                            <td className="text-end">{invoice.shipping_charge || "£65.00"}</td>
                          </tr>
                          <tr className="border-top border-top-dashed fs-15">
                            <th scope="row">Total Amount</th>
                            <th className="text-end">{invoice.total_amount || invoice.amount || "£798.47"}</th>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                    <div className="mt-3">
                      <h6 className="text-muted text-uppercase fw-semibold mb-3">
                        Payment Details:
                      </h6>
                      <p className="text-muted mb-1">
                        Payment Method:{" "}
                        <span className="fw-medium" id="payment-method">{paymentDetails.method || "Mastercard"}</span>
                      </p>
                      <p className="text-muted mb-1">
                        Card Holder:{" "}
                        <span className="fw-medium" id="card-holder-name">{paymentDetails.card_holder || invoice.name || "David Nichols"}</span>
                      </p>
                      <p className="text-muted mb-1">
                        Card Number:{" "}
                        <span className="fw-medium" id="card-number">{paymentDetails.card_number || "xxx xxxx xxxx 1234"}</span>
                      </p>
                      <p className="text-muted">
                        Total Amount: <span className="fw-medium" id="">{paymentDetails.total_amount || invoice.amount || "£798.47"}</span>
                      </p>
                    </div>
                    <div className="mt-4">
                      <div className="alert alert-info">
                        <p className="mb-0">
                          <span className="fw-semibold">NOTES:</span>
                          <span id="note"> All accounts
                            are to be paid within 7 days from receipt of invoice. To
                            be paid by cheque or credit card or direct payment online.
                            If account is not paid within 7 days the credits details
                            supplied as confirmation of work undertaken will be
                            charged the agreed quoted fee noted above.
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="hstack gap-2 justify-content-end d-print-none mt-4">
                      {invoice?.payment_status?.toLowerCase() !== 'paid' && (
                        <Link to={`/apps-invoices-edit/${id}`} className="btn btn-warning">
                          <i className="ri-edit-line align-bottom me-1"></i> Edit
                        </Link>
                      )}
                      <Link
                        to="#"
                        onClick={printInvoice}
                        className="btn btn-success"
                      >
                        <i className="ri-printer-line align-bottom me-1"></i> Print
                      </Link>
                      <Link to="#" className="btn btn-primary">
                        <i className="ri-download-2-line align-bottom me-1"></i>{" "}
                        Download
                      </Link>
                    </div>
                  </CardBody>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row >
      </Container >
    </div >
  );
};

export default InvoiceDetails;
